// src/pages/admin/integrations/shopify/hooks/useShopify.ts
import { useCallback, useEffect, useState } from 'react';
import {
  MOCK_SHOPIFY_ACTIVITY,
  MOCK_SHOPIFY_FLOWS,
  MOCK_SHOPIFY_INFO,
  MOCK_TEMPLATES,
} from '../../pages/integrations/zoho-CMR/MockData';
import type {
  ShopifyActivityData,
  ShopifyFlow,
  ShopifyFlowsData,
  ShopifyInfo,
  ShopifySettings,
  Template,
} from '../../types/integrations';

export interface UseShopifyResult {
  info: ShopifyInfo | null;
  loading: boolean;
  error: string;
  reload: () => Promise<void>;
  disconnect: () => Promise<void>;
  saveSettings: (settings: ShopifySettings) => Promise<void>;
}

export function useShopify(): UseShopifyResult {
  const [info, setInfo] = useState<ShopifyInfo | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      // const data = await api.get('SHOPIFY');
      setInfo(MOCK_SHOPIFY_INFO);
      setError('');
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Something went wrong');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  const disconnect = useCallback(async () => {
    // await api.disconnect('SHOPIFY');
    setInfo((prev) =>
      prev ? { ...prev, status: 'NOT_CONNECTED', account: null } : prev
    );
  }, []);

  const saveSettings = useCallback(async (settings: ShopifySettings) => {
    // await api.saveSettings('SHOPIFY', settings);
    setInfo((prev) => (prev ? { ...prev, settings } : prev));
  }, []);

  return { info, loading, error, reload: load, disconnect, saveSettings };
}

export interface UseShopifyFlowsResult {
  data: ShopifyFlowsData | null;
  templates: Template[];
  saveFlow: (key: string, payload: Partial<ShopifyFlow>) => Promise<void>;
  testFlow: (key: string, phone: string) => Promise<void>;
}

export function useShopifyFlows(): UseShopifyFlowsResult {
  const [data, setData] = useState<ShopifyFlowsData | null>(null);
  const [templates, setTemplates] = useState<Template[]>([]);

  useEffect(() => {
    // api.flows('SHOPIFY').then(setData);
    // api.templates().then(setTemplates);
    setData(MOCK_SHOPIFY_FLOWS);
    setTemplates(MOCK_TEMPLATES);
  }, []);

  const saveFlow = async (_key: string, _payload: Partial<ShopifyFlow>) => {
    // await api.saveFlow(key, payload);
  };

  const testFlow = async (_key: string, _phone: string) => {
    // await api.testFlow(key, phone);
  };

  return { data, templates, saveFlow, testFlow };
}

export function useShopifyActivity(): { data: ShopifyActivityData | null } {
  const [data, setData] = useState<ShopifyActivityData | null>(null);
  useEffect(() => {
    // api.activity('SHOPIFY').then(setData);
    setData(MOCK_SHOPIFY_ACTIVITY);
  }, []);
  return { data };
}